import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { FeaturedCategorySection } from '@modules/articles/type';
import FeaturedSectionDesktop from './FeaturedSection.desktop';
import FeaturedSectionMobile from './FeaturedSection.mobile';

export interface FeaturedSectionProps {
    featuredSection: FeaturedCategorySection;
    showFeaturedSlides?: boolean;
}

const FeaturedSection: React.FC<FeaturedSectionProps> = (props) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <>
            {isMobile ? (
                <FeaturedSectionMobile {...props} />
            ) : (
                <FeaturedSectionDesktop {...props} />
            )}
        </>
    );
};

export default FeaturedSection;
